import React, { useEffect, useState } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRow, IonCol, IonLabel, IonInput, IonItem, IonCard, IonCardContent, IonCardHeader, useIonToast, useIonAlert, useIonLoading, IonIcon, IonButton, IonList, IonButtons, IonSearchbar, IonCardTitle, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react'
import { menuController } from '@ionic/core';
import CryptoJS from "crypto-js";
import { calculator } from 'ionicons/icons';

const Tools = () => {



    useIonViewDidEnter(() => {
        menuController.enable(false, 'mainmenu')
    })

    useIonViewWillLeave(() => {
        menuController.enable(true, 'mainmenu')
    })

    const [showGenerate, setShowGenerate] = useState(false);
    const [showTool, setShowTool] = useState(false);
    const [showPrompt, dismissPrompt] = useIonAlert();

    useEffect(() => {

        showPrompt({
            header: 'Enter Secret Keys',
            inputs: [
                {
                    name: 'password',
                    type: 'password',
                    placeholder: 'Password'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: (data) => {
                        if (data.password === '9406707245') {
                            setShowTool(true);
                        } else {
                            setShowTool(false);
                            dismissPrompt();
                        }
                    }
                }
            ]
        });


    }, [dismissPrompt, showPrompt]);

    return showTool ? (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        {/* <IonBackButton defaultHref="/Dev" /> */}
                    </IonButtons>
                    <IonTitle>Tools</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => {
                            setShowGenerate(!showGenerate)
                        }}>
                            <IonIcon slot="icon-only" icon={calculator} />
                        </IonButton>
                    </IonButtons>


                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">

                <KeyGenerator hidden={!showGenerate} />
                <UserAccountSearch />


            </IonContent>
        </IonPage>
    ) : (<></>)
}

const UserAccountSearch = () => {
    const [list, setList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [showLoading, dismissLoading] = useIonLoading();


    useEffect(() => {
        showLoading({
            message: 'Loading...',
            spinner: 'dots',
            translucent: true,
        });

        fetch('/api/db/contacts').then(res => res.json()).then(data => {
            setList(data);
            setFilteredList(data);
            dismissLoading();
        })
    }, [dismissLoading, showLoading])

    function handleSearch(e) {
        if (e.target.value.length > 0) {
            setFilteredList(list.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase())));
        } else {
            setFilteredList(list);
        }
    }
    return (<>
        <IonSearchbar placeholder="Search" onIonChange={handleSearch} />

        <IonList>
            <IonItem color='light'>
                <IonCol>
                    <IonLabel>Name</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Email</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Phone</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Address</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Serial</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Registered Date</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Expiry Date</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Product Type</IonLabel>
                </IonCol>
            </IonItem>

            {filteredList.map((item, index) => (
                <IonItem key={index}>
                    <IonCol>
                        <IonInput readonly value={item.name}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.email}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.contact}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.location}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.serial}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.registryDate}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.expirationDate}></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonInput readonly value={item.type}></IonInput>
                    </IonCol>
                </IonItem>
            ))}
        </IonList>
    </>)

}

const KeyGenerator = ({ hidden }) => {
    const [name, setName] = useState('');
    const [ip, setIp] = useState('');
    const [hash, setHash] = useState('');
    const [toastPresent, toastDismiss] = useIonToast()

    function copyClipboard() {
        navigator.clipboard.writeText(hash);
        toastDismiss();
        toastPresent({
            message: 'Copied to clipboard',
            color: 'warning',
            duration: 2000,
            position: 'top',

        })
    }

    function handleGenerator(e) {
        e.preventDefault();

        let hash = CryptoJS.SHA1(ip + name).toString();
        setHash(hash);
        copyClipboard();
    }

    return (
        <form onSubmit={handleGenerator}>
            <IonRow hidden={hidden} className='ion-justify-content-center'>
                <IonCol sizeMd='6' sizeSm='11'>
                    <IonCard >
                        <IonCardHeader>
                            <IonCardTitle class='ion-text-center'>Key Generator</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <IonRow>
                                <IonCol>
                                    <IonItem>
                                        <IonLabel position="floating">Name</IonLabel>
                                        <IonInput required value={name} onIonChange={e => setName((e.detail.value).trim())}></IonInput>
                                    </IonItem>
                                </IonCol>
                                <IonCol>
                                    <IonItem>
                                        <IonLabel position="floating">Serial</IonLabel>
                                        <IonInput required value={ip} onIonChange={e => setIp((e.detail.value).trim())}></IonInput>
                                    </IonItem>
                                </IonCol>
                            </IonRow>
                            <IonButton type="submit" expand="block">Generate Key</IonButton>

                            <IonItem hidden={!hash} lines='none' color={"success"} onClick={copyClipboard} >
                                <IonTitle className='ion-text-center'>{hash}</IonTitle>
                            </IonItem>

                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </IonRow>

        </form>
    )
}


export default Tools
